export const reportingDataConstants = {
    FETCH_REPORTING_DATA_REQUESTING: "FETCH_REPORTING_DATA_REQUESTING",
    FETCH_REPORTING_DATA_FETCHED: "FETCH_REPORTING_DATA_FETCHED",
    FETCH_REPORTING_DATA_FAILED: "FETCH_REPORTING_DATA_FAILED",

    SAVE_ACTIVE_CENTRAL_PATIENT_DATA: "SAVE_ACTIVE_CENTRAL_PATIENT_DATA"
  };
  